import { useForm } from "react-hook-form";
import { useRecoilState } from "recoil";
import useExamRoomActions from "../../../api/hooks/admin/examRoom";
import { isExamRoomAddModalOpenState } from "../../../recoil/admin/examRoom";
import { hourOptions, minuteOptions } from "../../../static";
import AdminExamRoomSelect from "../../modules/admin/AdminExamRoomSelect";
import Modal from "../../modules/layout/Modal";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import React from "react";
import Select from "../../atoms/input/Select";
import { speakLanguageOption } from "../../../static";
import { useState } from "react";

const ExamRoomAddModal = () => {
  const { register, handleSubmit, reset, watch } = useForm();

  const { createExamRoom } = useExamRoomActions();
  const [isExamRoomModalOpen, setIsExamRoomModalOpen] = useRecoilState(
    isExamRoomAddModalOpenState
  );

  const timeConverter = (time) => {
    if (time.length === 1) return `0${time}`;

    return time;
  };

  const YYYYMMDDHHmm = (date, hour, minute) => {
    return `${date.split("-").join("")}${timeConverter(hour)}${timeConverter(
      minute
    )}`;
  };

  // Access the client
  const queryClient = useQueryClient();

  // Mutations
  const mutation = useMutation(createExamRoom, {
    onSuccess: () => {
      alert("시험실을 추가했습니다.");
      setIsExamRoomModalOpen(false);
      reset();
      // Invalidate and refetch
      queryClient.invalidateQueries(["fetchExamRoomList"]);
      return;
    },
    onError: () => {
      alert("실패");
    },
  });

  const [room_type, setRoom_type] = useState(3);
  const onSubmit = async (data) => {
    // console.log("regist_end_time, regist_start_time, test_end_time, test_start_time")
    var regist_end_time = YYYYMMDDHHmm(
      data.regist_end_date,
      data.regist_end_hour,
      data.regist_end_minute
    );
    var regist_start_time = YYYYMMDDHHmm(
      data.regist_start_date,
      data.regist_start_hour,
      data.regist_start_minute
    );
    var test_end_time = YYYYMMDDHHmm(
      data.test_end_date,
      data.test_end_hour,
      data.test_end_minute
    );
    var test_start_time = YYYYMMDDHHmm(
      data.test_start_date,
      data.test_start_hour,
      data.test_start_minute
    );
    if (regist_end_time <= regist_start_time) {
      alert("신청 종료시간이 시작시간보다 빠를 수 없습니다.");
      return;
    }
    if (test_end_time <= test_start_time) {
      alert("응시 종료시간이 시작시간보다 빠를 수 없습니다.");
      return;
    }

    const req = {
      group_title: data.group_title,
      titleText: data.title.trim() === "" ? " " : data.title,
      room_type: parseInt(room_type),
      regist_period_starttime: YYYYMMDDHHmm(
        data.regist_start_date,
        data.regist_start_hour,
        data.regist_start_minute
      ),
      regist_period_endtime: YYYYMMDDHHmm(
        data.regist_end_date,
        data.regist_end_hour,
        data.regist_end_minute
      ),
      test_period_starttime: YYYYMMDDHHmm(
        data.test_start_date,
        data.test_start_hour,
        data.test_start_minute
      ),
      test_period_endtime: YYYYMMDDHHmm(
        data.test_end_date,
        data.test_end_hour,
        data.test_end_minute
      ),
      file: data.file[0],
    };

    // console.log("req", req);

    mutation.mutate(req);
  };

  return (
    <Modal isOpen={isExamRoomModalOpen}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="modal fade" id="plus" style={{ display: "block" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header flex">
                <p className="sign-top-title" id="staticBackdropLabel">
                  OPIC 시험코드
                </p>
                <button
                  type="button"
                  className="close"
                  onClick={() => setIsExamRoomModalOpen(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="modal-title">
                  <p>시험실추가</p>
                </div>
                <div className="plus-box">
                  <p className="plus-title">그룹이름</p>
                  <input
                    type="text"
                    className="plus-title-input"
                    style={{ width: "100%" }}
                    {...register("group_title", { required: true })}
                  />
                </div>
                <div className="plus-box">
                  <p className="plus-title">제목</p>
                  <input
                    type="text"
                    className="plus-title-input"
                    style={{ width: "100%" }}
                    {...register("title")}
                  />
                </div>
                <div className="plus-box">
                  <p className="plus-title">신청기간</p>
                  <div className="period-box">
                    <span className="date-period">시작일시</span>
                    <div className="dropdown period-dropdown">
                      <input
                        type="date"
                        className="period-input"
                        {...register("regist_start_date", { required: true })}
                      />
                      <AdminExamRoomSelect
                        options={hourOptions}
                        refs={{
                          ...register("regist_start_hour", {
                            required: true,
                          }),
                        }}
                      />
                      <AdminExamRoomSelect
                        options={minuteOptions}
                        refs={{
                          ...register("regist_start_minute", {
                            required: true,
                          }),
                        }}
                      />
                    </div>
                  </div>
                  <div>
                    <span className="date-period">종료일시</span>
                    <div className="dropdown period-dropdown">
                      <input
                        type="date"
                        className="period-input"
                        {...register("regist_end_date", { required: true })}
                      />
                      <AdminExamRoomSelect
                        options={hourOptions}
                        refs={{
                          ...register("regist_end_hour", {
                            required: true,
                          }),
                        }}
                      />
                      <AdminExamRoomSelect
                        options={minuteOptions}
                        refs={{
                          ...register("regist_end_minute", {
                            required: true,
                          }),
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="plus-box">
                  <p className="plus-title">응시기간</p>
                  <div className="period-box">
                    <span className="date-period">시작일시</span>
                    <input
                      type="date"
                      className="period-input"
                      {...register("test_start_date", { required: true })}
                    />
                    <div className="dropdown period-dropdown">
                      <AdminExamRoomSelect
                        options={hourOptions}
                        refs={{
                          ...register("test_start_hour", {
                            required: true,
                          }),
                        }}
                      />
                      <AdminExamRoomSelect
                        options={minuteOptions}
                        refs={{
                          ...register("test_start_minute", {
                            required: true,
                          }),
                        }}
                      />
                    </div>
                  </div>
                  <div>
                    <span className="date-period">종료일시</span>
                    <input
                      type="date"
                      className="period-input"
                      {...register("test_end_date", { required: true })}
                    />
                    <div className="dropdown period-dropdown">
                      <AdminExamRoomSelect
                        options={hourOptions}
                        refs={{
                          ...register("test_end_hour", {
                            required: true,
                          }),
                        }}
                      />
                      <AdminExamRoomSelect
                        options={minuteOptions}
                        refs={{
                          ...register("test_end_minute", {
                            required: true,
                          }),
                        }}
                      />
                    </div>
                  </div>

                  <div className="plus-box">
                    <p className="plus-title">로고등록</p>
                    <label htmlFor="file" className="upload-btn file-btn">
                      파일선택
                    </label>
                    <input
                      type="text"
                      className="fileName"
                      id="fileName"
                      placeholder="선택된 파일 없음"
                      disabled
                      value={watch("file") ? watch("file")[0]?.name || "" : ""}
                      style={{ width: "60%" }}
                    />
                    <input
                      {...register("file")}
                      type="file"
                      id="file"
                      className="uploadBtn"
                      style={{ display: "none" }}
                    />
                  </div>
                  <div className="plus-box">
                    <p className="plus-title">시험 유형</p>
                    <Select
                      options={speakLanguageOption}
                      onChange={(e) => {
                        // console.log(e.target.value);
                        setRoom_type(e.target.value);
                      }}
                      value={room_type}
                    />
                  </div>
                  {/* <div className="plus-box">
                    <p className="plus-title">접수페이지</p>
                    <Select options={[{ value: "0", label: "KOICA 접수" }]} />
                  </div> */}
                </div>
                <div className="modal-footer text-align-right">
                  <button
                    type="button"
                    className="modal-btn modal-close-btn"
                    onClick={() => setIsExamRoomModalOpen(false)}
                  >
                    닫기
                  </button>
                  <button type="submit" className="modal-btn modal-save-btn">
                    저장
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </Modal>
  );
};
export default ExamRoomAddModal;
